import { Table, Tooltip, Button, Popconfirm, message, Drawer } from "antd";
import React, { useEffect, useState } from "react";
import moment from "moment";
import { createComponentStore } from "easy-peasy";
import { PaymentStoreModel, ACTION_TYPES } from "store/models/payments";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PaymentForm from "./form";
import { DISPLAY_MODE } from "Constants";
import { formatCurrency } from "Utils";

const usePaymentStore = createComponentStore(PaymentStoreModel);

export default function ContractPayments({
  payments,
  contract,
  formVisibility,
  handleFormVisibility,
  onRefresh,
  mode = DISPLAY_MODE.EDIT,
  ...props
}) {
  const [store, actions] = usePaymentStore();
  const [selectedPayment, setSelectedPayment] = useState(null);

  useEffect(() => {
    if (!formVisibility) setSelectedPayment(null);
  }, [formVisibility]);

  useEffect(() => {
    switch (store.process) {
      case ACTION_TYPES.FETCHED_DATA:
        onRefresh(store.data?.content || store.data);
        break;
      case ACTION_TYPES.REMOVED_DATA:
        message.success("Tahsilat kaldırıldı.");
        refreshData();
        break;
      default:
        break;
    }
  }, [store.process]);

  useEffect(() => {
    actions.setData(payments);
  }, [payments]);

  const refreshData = () => {
    actions.getContractPayments({ ContractId: contract.id });
  };

  const columns = [
    {
      title: "Ödeme Türü",
      dataIndex: ["conditionType", "description"],
      key: "conditionType",
    },
    {
      title: "Tutar",
      dataIndex: "amount",
      key: "amount",
      render: (text, record) => {
        return formatCurrency(record.amount || 0, record.currency);
      },
    },
    {
      title: "Ödeme Tarihi",
      dataIndex: "paymentDate",
      render: (text, record, index) => {
        return moment(record.paymentDate).format("DD.MM.YYYY");
      },
    },
    /*{
      title: "Status",
      dataIndex: "approvalType",
      render: (text, record, index) => {
        switch (text) {
          case "APPROVE":
            return "Onaylandı";
          case "REJECT ":
            return "Reddedildi";
          default:
            return "Onay Bekliyor";
        }
      },
    },*/
    mode === DISPLAY_MODE.EDIT
      ? {
          title: "İşlemler",
          width: 150,
          fixed: "right",
          dataIndex: "operation",
          render: (text, record) => {
            return (
              <span>
                <Tooltip title="Düzenle">
                  <Button
                    style={{ marginRight: 8 }}
                    onClick={() => {
                      setSelectedPayment(record);
                      handleFormVisibility(true);
                    }}
                  >
                    <FontAwesomeIcon icon={["fas", "edit"]} />
                  </Button>
                </Tooltip>
                <Popconfirm
                  title="Emin Misin?"
                  onConfirm={() =>
                    actions.remove({ id: record.id, version: record.version })
                  }
                  icon={
                    <FontAwesomeIcon
                      icon={["far", "trash-alt"]}
                      style={{ color: "red" }}
                    />
                  }
                  okText="Kaldır"
                  cancelText="Geri"
                >
                  <Tooltip title="Kaldır" placement="bottom">
                    <Button type="danger">
                      <FontAwesomeIcon icon={["far", "trash-alt"]} />
                    </Button>
                  </Tooltip>
                </Popconfirm>
              </span>
            );
          },
        }
      : {},
  ];
  return (
    <>
      <Table
        size="small"
        scroll={{ x: 1000 }}
        loading={store.process === ACTION_TYPES.FETCHING_DATA}
        bordered
        rowKey={(row) => row.id}
        dataSource={store.data?.content || store.data}
        columns={columns}
        onChange={(paging, filters, sorter) => {
          actions.search({
            ContractId: contract.id,
            page: paging.current - 1,
            size: paging.pageSize,
          });
        }}
        pagination={
          store.data?.pageable
            ? {
                current: store.data.pageable?.pageNumber + 1,
                total: store.data.totalElements,
                pageSize: store.data.pageable?.pageSize,
              }
            : false
        }
      />
      <Drawer
        width={"45%"}
        placement="right"
        bodyStyle={{ overflowY: "auto", height: "100%", padding: "20px 30px" }}
        destroyOnClose={true}
        title="Tahsilat"
        visible={formVisibility}
        onClose={() => handleFormVisibility(false)}
      >
        <PaymentForm
          onSubmit={() => {
            refreshData();
            handleFormVisibility(false);
          }}
          contract={contract}
          payment={selectedPayment}
        />
      </Drawer>
    </>
  );
}
